// @flow
import React from 'react';

// Creates comma-separated list of responsive images
// Default image is expected to end with "-default.jpg"
const generateSrcSet = (defaultImage: string) => {
  if (!defaultImage) {
    return null;
  }

  const widths = ['800w', '1200w', '1600w', '1800w'];
  const getPathRegEx = /\/(?=[^/]*$)/;
  const getFilenameRegEx = /-default\.(?=.{3,4}$)/;

  const [path, filename] = defaultImage.split(getPathRegEx);
  const [baseFilename, extension] = filename.split(getFilenameRegEx);

  const responsivePath = path.concat('/responsive');

  // ".../image-800w.jpg 800w"
  const srcSet = widths.map(size => `${responsivePath}/${baseFilename}-${size}.${extension} ${size}`);

  // Add original as default
  srcSet.push(defaultImage);

  return srcSet.join(', ');
};

type Props = {
  alt?: string,
  src: string,
  className?: string
}

const ResponsiveImage = (props: Props) => {
  const {
    alt = '',
    src,
    className
  } = props;

  const srcSet = generateSrcSet(src);

  return (
    <img
      alt={alt}
      src={src}
      srcSet={srcSet}
      className={className}
    />
  );
};

ResponsiveImage.defaultProps = {
  alt: '',
  className: undefined
};

export default ResponsiveImage;
